<app-licenses-licenses-list-card></app-licenses-licenses-list-card>
